module.exports = __webpack_public_path__ + "static/media/session-image.00989e6a.svg";